'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { HeroParkDaAlterosa } from '@/components/sections/park-alterosa/HeroParkDaAlterosa';

const LocationParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/LocationParkDaAlterosa').then((mod) => mod.LocationParkDaAlterosa), { ssr: false });
const InteriorsParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/InteriorsParkDaAlterosa').then((mod) => mod.InteriorsParkDaAlterosa), { ssr: false });
const FloorPlansParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/FloorPlansParkDaAlterosa').then((mod) => mod.FloorPlansParkDaAlterosa), { ssr: false });
const SurroundingsMapParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/SurroundingsMapParkDaAlterosa').then((mod) => mod.SurroundingsMapParkDaAlterosa), { ssr: false });
const LeisureAreaPlanParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/LeisureAreaPlanParkDaAlterosa').then((mod) => mod.LeisureAreaPlanParkDaAlterosa), { ssr: false });
const ImplantationPlanParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/ImplantationPlanParkDaAlterosa').then((mod) => mod.ImplantationPlanParkDaAlterosa), { ssr: false });
const AudienceFamilyParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/AudienceFamilyParkDaAlterosa').then((mod) => mod.AudienceFamilyParkDaAlterosa), { ssr: false });
const BuildingFacadeParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/BuildingFacadeParkDaAlterosa').then((mod) => mod.BuildingFacadeParkDaAlterosa), { ssr: false });
const MinhaCasaMinhaVidaParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/MinhaCasaMinhaVidaParkDaAlterosa').then((mod) => mod.MinhaCasaMinhaVidaParkDaAlterosa), { ssr: false });
const ValuesParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/ValuesParkDaAlterosa').then((mod) => mod.ValuesParkDaAlterosa), { ssr: false });
const ContactFormParkDaAlterosa = dynamic(() => import('@/components/sections/park-alterosa/ContactFormParkDaAlterosa').then((mod) => mod.ContactFormParkDaAlterosa), { ssr: false });
const VideoSection = dynamic(() => import('@/components/sections/VideoSection'), { ssr: false });
const Footer = dynamic(() => import('@/components/Footer'), { ssr: false });

export default function ParkDaAlterosaCrossfade() {
  const [showStickyBar, setShowStickyBar] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setShowStickyBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="park-alterosa-page relative flex w-full flex-col overflow-x-hidden bg-white font-park-alterosa">
      <HeroParkDaAlterosa />
      <LocationParkDaAlterosa />
      <BuildingFacadeParkDaAlterosa />
      <MinhaCasaMinhaVidaParkDaAlterosa />
      <SurroundingsMapParkDaAlterosa />
      <InteriorsParkDaAlterosa />
      <FloorPlansParkDaAlterosa />
      <ImplantationPlanParkDaAlterosa />
      <LeisureAreaPlanParkDaAlterosa />
      <AudienceFamilyParkDaAlterosa />
      <ValuesParkDaAlterosa />
      <ContactFormParkDaAlterosa />
      <VideoSection />
      <Footer />

      {/* Sticky Bottom CTA Bar (Mobile Only) */}
      {showStickyBar && (
        <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-[#17453a]/12 bg-white/95 py-3 shadow-[0_-10px_34px_rgba(22,69,58,0.14)] backdrop-blur-md transition-all duration-300 lg:hidden">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
            <div className="flex items-center gap-2">
              <p className="margin-0 text-xs font-semibold text-[#20302a] sm:text-sm">
                Park Alterosa <span className="hidden font-normal text-[#53655d] xs:inline">· 2 quartos</span>
              </p>
            </div>
            <a
              href="#contato"
              className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-[#ff7d2a] px-6 text-sm font-semibold text-white shadow-md transition hover:-translate-y-0.5 hover:bg-[#d06019]"
            >
              Quero conhecer →
            </a>
          </div>
        </div>
      )}
      <style jsx global>{`
        .park-alterosa-page {
          --park-orange: #f4772e;
          --park-orange-action: #ff7d2a;
          --park-orange-dark: #d06019;
          --park-green: #17453a;
          --park-green-medium: #4ea075;
          --park-green-light: #80caa3;
          --park-mint: #afffd5;
          --park-ink: #20302a;
          --park-muted: #53655d;
          --park-off-white: #f8f6f1;
          font-family: var(--font-park-alterosa), Arial, sans-serif;
          font-synthesis: none;
        }
        .park-alterosa-page svg[data-type='ugc'],
        .park-alterosa-page svg[data-type='color'] { display: none; }
      `}</style>
    </div>
  );
}
